import angular from 'angular';
import { clickDialogDirective } from './ClickDialogDirective';
import { csmContent } from './csmContent';
import uiBootstrap from 'angular-ui-bootstrap';

/**
* @ngdoc    overview
* @name     csm.ui
* @description
* UI dom tools
**/
export default angular
  .module('csm.ui', [uiBootstrap])
  .factory("ClickDialogDirective", clickDialogDirective)
  .directive("csmContent", csmContent)
  .name;
